import { FC } from 'react'

import { DOCUMENT_ACTION_TYPE, DocumentActionButton } from '../DocumentActionButton'
import { UploadInput } from './UploadInput'

type FileUploadButtonProps = {
  uploadFile: (file: File) => void
  inputName: string
  tooltip: string
  allowedFormats?: string[]
}

export const FileUploadButton: FC<FileUploadButtonProps> = ({ uploadFile, tooltip, inputName, allowedFormats }) => (
  <label htmlFor={inputName}>
    <DocumentActionButton
      title={tooltip}
      actionType={DOCUMENT_ACTION_TYPE.UPLOAD}
      onClick={() => {
        document.getElementsByName(inputName)[0].click()
      }}
      data-tracking-id="shipment-document-upload"
    />
    <UploadInput uploadFile={uploadFile} name={inputName} allowedFormats={allowedFormats} />
  </label>
)
